import { render, staticRenderFns } from "./ManagementControlView.vue?vue&type=template&id=12da66b2&scoped=true"
import script from "./ManagementControlView.vue?vue&type=script&lang=js"
export * from "./ManagementControlView.vue?vue&type=script&lang=js"
import style0 from "./ManagementControlView.vue?vue&type=style&index=0&id=12da66b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da66b2",
  null
  
)

export default component.exports